import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const disapproveCategory = async (categoryId: string) => {
  const [response, bodyOrError] = await Api.delete(`categories/${categoryId}`);
  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};
export const useDisapproveCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'disapproveCategory',
    (data: { categoryId: string }) => {
      return disapproveCategory(data.categoryId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['suggestedCategories']);
      },
    },
  );
};
